import React from 'react';

import { Column } from '..';
import './WhatApp.scss';

export const WhatAppClient = ({ children }) => {
  return <Column customClass="whatAppClientContainer">{children}</Column>;
};
